export const blogPosts = [
  {
    id: 1,
    title: '10 Interior Design Trends Shaping 2024',
    excerpt: 'Discover the latest trends in interior design that are transforming modern living spaces this year.',
    category: 'Interior Design',
    date: 'March 15, 2024',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20modern%20interior%20design%20showcase%20featuring%20elegant%20contemporary%20furniture%20with%20natural%20sunlight%20streaming%20through%20large%20windows%20creating%20warm%20ambiance%20in%20sophisticated%20living%20room%20with%20neutral%20color%20palette%20and%20minimalist%20aesthetic%20clean%20lines%20premium%20materials&width=800&height=500&seq=blog1trend&orientation=landscape',
    author: {
      name: 'Sarah Mitchell',
      role: 'Lead Interior Designer',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20interior%20designer%20portrait%20confident%20smile%20modern%20office%20background%20business%20attire&width=100&height=100&seq=author1&orientation=squarish'
    }
  },
  {
    id: 2,
    title: 'The Art of Minimalist Web Design',
    excerpt: 'Learn how minimalist principles can create powerful and engaging digital experiences.',
    category: 'Web Design',
    date: 'March 10, 2024',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=clean%20minimalist%20web%20design%20interface%20displayed%20on%20modern%20computer%20screen%20showing%20elegant%20typography%20and%20white%20space%20with%20simple%20navigation%20contemporary%20digital%20layout%20professional%20workspace%20aesthetic%20bright%20natural%20lighting&width=800&height=500&seq=blog2webdesign&orientation=landscape',
    author: {
      name: 'Michael Chen',
      role: 'Creative Director',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20web%20designer%20portrait%20creative%20director%20modern%20studio%20background%20casual%20business%20attire&width=100&height=100&seq=author2&orientation=squarish'
    }
  },
  {
    id: 3,
    title: 'Creating Sustainable Living Spaces',
    excerpt: 'Explore eco-friendly design solutions that combine style with environmental responsibility.',
    category: 'Sustainability',
    date: 'March 5, 2024',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20sustainable%20eco-friendly%20interior%20design%20featuring%20natural%20organic%20materials%20abundant%20green%20plants%20wooden%20textures%20environmentally%20conscious%20living%20space%20with%20natural%20sunlight%20warm%20earth%20tones%20biophilic%20design%20elements&width=800&height=500&seq=blog3sustain&orientation=landscape',
    author: {
      name: 'Emma Rodriguez',
      role: 'Sustainability Consultant',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20sustainability%20consultant%20portrait%20friendly%20smile%20natural%20background%20business%20casual%20attire&width=100&height=100&seq=author3&orientation=squarish'
    }
  },
  {
    id: 4,
    title: 'Color Psychology in Design',
    excerpt: 'Understanding how colors influence mood and behavior in both physical and digital spaces.',
    category: 'Design Theory',
    date: 'February 28, 2024',
    readTime: '8 min read',
    image: 'https://readdy.ai/api/search-image?query=vibrant%20color%20palette%20design%20showcase%20featuring%20artistic%20arrangement%20of%20paint%20swatches%20mood%20boards%20and%20color%20theory%20samples%20with%20rainbow%20spectrum%20professional%20design%20studio%20setting%20creative%20workspace%20aesthetic&width=800&height=500&seq=blog4color&orientation=landscape',
    author: {
      name: 'David Park',
      role: 'Design Psychologist',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20design%20consultant%20portrait%20thoughtful%20expression%20modern%20office%20background%20smart%20casual%20attire&width=100&height=100&seq=author4&orientation=squarish'
    }
  }
];
